module.exports = __webpack_public_path__ + "img/cca-clogo.4e135c57.png";